import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import Form from './forms/EventForm';
import List from './lists/event/EventList';
import Calendar from './lists/event/EventCalendar';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {SelectButton} from "primereact/selectbutton";
import EventReservationEditor from "./EventReservationEditor";
import ModalEditor from "./ModalEditor";
import Select from "../form/Select";
import {list} from "../../utils/array";

const listTypes = [
    {label: 'Naptár', value: 'calendar', type: Calendar},
    {label: 'Táblázat', value: 'table', type: List}
];

class EventEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            listType: this.props.listType || 'table',
            programs: [],
            locations: []
        }
    }


    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        const ListType = listTypes.find((v) => v.value === this.state.listType).type || List;

        let subFilter = [];
        if (this.state.programs.length && this.state.locations.length) {
            subFilter = [{filters: [{field: "program", value: this.state.programs, operator: "in"}, {field: "locations", value: this.state.programs, operator: "in"}], operator: "or"}];
        } else if (this.state.programs.length) {
            subFilter = [{field: "program", value: this.state.programs, operator: "in"}];
        } else if (this.state.locations.length) {
            subFilter = [{field: "locations", value: this.state.locations, operator: "in"}];
        }
        let filter = list(this.props.filter, ...subFilter);
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Események"}
                    actions={<SelectButton
                        value={this.state.listType}
                        options={listTypes}
                        onChange={(e) => this.setState({listType: e.value || listTypes[0].value})}
                    />}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    {!this.props.presets && <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <Select
                                    storeType="remote"
                                    component="Program"
                                    name="programs"
                                    value={this.state.programs}
                                    label="Program(ok)"
                                    labelKey="name"
                                    isMulti={true}
                                    objectValue={false}
                                    saveChanges={(field, value) => {
                                        this.setState({
                                            [field]: value
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <Select
                                    storeType="remote"
                                    component="location"
                                    name="locations"
                                    value={this.state.locations}
                                    label="Helszín(ek)"
                                    labelKey="name"
                                    isMulti={true}
                                    objectValue={false}
                                    saveChanges={(field, value) => {
                                        this.setState({
                                            [field]: value
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>}
                    <ListType ref={(el) => this.list = el} {...this.props} filter={filter} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Esemény"}
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <Form {...this.props} />
                </Editor>
                <Other>
                {
                    this.props.values[this.props.componentConfig.idfield] &&
                    <EventReservationEditor
                        editorContext="EventEventReservationEditor"
                        gridid={"EventEventReservationList"}
                        presets={{event: this.props.values}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        listFilter={[
                            {
                                field: "event",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                    />
                }
                </Other>
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "Event",
    WrappedComponent: EventEditor,
    props: {
        view: "admin",
        componentActions: (action, data, params) => {
            params.repeated = data.repeated;
            return {action,data,params};
        }
    }
});
